import { Component } from '@angular/core';
import { SitesService } from '../services/sites.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';

  constructor(
    private sitesService: SitesService
  ) {}

  ngOnInit() {
    this.sitesService.getSites().subscribe(sites => {
      console.log('sites', sites);
    })
  }

  createSite() {
    this.sitesService.createSite({ label: 'blah' });
  }
}
